import React from 'react'
import './WholeDashBoard.css'
function WholeDashBoard() {

  return (
    <div>
      <div className="container-fluid pt-5 mt-5 pb-5">
        {/* Widget Style 1 Start */}
        <div className="row">
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style1">
              <div className="d-flex flex-wrap align-items-center">
                <div className="circle-icon">
                  <div className="icon border-radius-100 font-24 text-blue"><i className="fa fa-user" aria-hidden="true" /></div>
                </div>
                <div className="widget-data">
                  <div className="weight-800 font-18">2020</div>
                  <div className="weight-500">Contact</div>
                </div>
                <div className="progress-data">
                  <div id="chart" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white widget-style1 border-radius-10 height-100-p box-shadow">
              <div className="d-flex flex-wrap align-items-center">
                <div className="circle-icon">
                  <div className="icon border-radius-100 font-24 text-blue"><i className="fa fa-handshake-o" aria-hidden="true" /></div>
                </div>
                <div className="widget-data">
                  <div className="weight-800 font-18">400</div>
                  <div className="weight-500">Deals</div>
                </div>
                <div className="progress-data">
                  <div id="chart2" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style1">
              <div className="d-flex flex-wrap align-items-center">
                <div className="circle-icon">
                  <div className="icon border-radius-100 font-24 text-blue"><i className="fa fa-bullhorn" aria-hidden="true" /></div>
                </div>
                <div className="widget-data">
                  <div className="weight-800 font-18">350</div>
                  <div className="weight-500">Campaign</div>
                </div>
                <div className="progress-data">
                  <div id="chart3" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style1">
              <div className="d-flex flex-wrap align-items-center">
                <div className="circle-icon">
                  <div className="icon border-radius-100 font-24 text-blue"><i className="fa fa-dollar" aria-hidden="true" /></div>
                </div>
                <div className="widget-data">
                  <div className="weight-800 font-18">$6060</div>
                  <div className="weight-500">Worth</div>
                </div>
                <div className="progress-data">
                  <div id="chart4" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Widget Style 1 End */}
        <div className="row">
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style2">
              <div className="widget-data">
                <div className="weight-800 font-24">11,020</div>
                <div className="weight-500 font-18">Online Signups</div>
              </div>
              <div className="progress-data">
                <div id="chart5" />
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style2">
              <div className="widget-data">
                <div className="weight-800 font-24">5,000</div>
                <div className="weight-500 font-18">New Visitors Today</div>
              </div>
              <div className="progress-data">
                <div id="chart6" />
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style2">
              <div className="widget-data">
                <div className="weight-800 font-24">9,000</div>
                <div className="weight-500 font-18">Weekly Total Order</div>
              </div>
              <div className="progress-data pl-20 pr-20">
                <div id="chart7" />
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style2">
              <div className="widget-data">
                <div className="weight-800 font-24">$60,600</div>
                <div className="weight-500 font-18">Total Revenue This Year</div>
              </div>
              <div className="progress-data">
                <div id="chart8" />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-8 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p pd-20">
              <h2 className="font-weight-700 font-24 mb-20">Activity</h2>
              <div id="chart9" />
            </div>
          </div>
          <div className="col-xl-4 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p pd-20">
              <h2 className="font-weight-700 font-24 mb-20">Lead Target</h2>
              <div id="chart10" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-500 font-20">Server</div>
                  <div className="weight-500 font-30 text-dark">75%</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-server" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-500 font-20">Traffic</div>
                  <div className="weight-500 font-30 text-dark">55%</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-line-chart" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-500 font-20">Email</div>
                  <div className="weight-500 font-30 text-dark">100</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-envelope-o" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="bg-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-500 font-20">Domians</div>
                  <div className="weight-500 font-30 text-dark">50</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-globe" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-3 mb-50">
            <div className="gradient-style1 text-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-400 font-20">Server</div>
                  <div className="weight-300 font-30">75%</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-server" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="gradient-style2 text-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-400 font-20">Traffic</div>
                  <div className="weight-300 font-30">55%</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-line-chart" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="gradient-style3 text-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-400 font-20">Email</div>
                  <div className="weight-300 font-30">100</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-envelope-o" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mb-50">
            <div className="gradient-style4 text-white box-shadow border-radius-10 height-100-p widget-style3">
              <div className="d-flex flex-wrap align-items-center">
                <div className="widget-data">
                  <div className="weight-400 font-20">Domians</div>
                  <div className="weight-300 font-30">50</div>
                </div>
                <div className="widget-icon">
                  <div className="icon"><i className="fa fa-globe" aria-hidden="true" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="bg-white box-shadow border-radius-10 height-100-p pd-20">
              <h2 className="font-weight-700 font-24 mb-20">Bubble Charts</h2>
              <div id="chart11" />
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default WholeDashBoard